import { propClassName } from '@/styles/SavedArticles';
import { cn } from 'lib/utils/cn';
import type { ClassNameProp, Component, ComponentProps } from 'types/component';

export interface SavedArticlesHeadlineProps extends ComponentProps<'h3'> {
  variant?: ClassNameProp<'default'>;
  colors?: ClassNameProp<'default'>;
  size?: ClassNameProp<'default'>;
}

export const SavedArticlesHeadlineComponent: Component<SavedArticlesHeadlineProps> = ({
  className,
  variant,
  colors,
  size,
  children,
  ...props
}) => {
  const variantClassName = propClassName('headline_variant', variant, 'default');
  const colorsClassName = propClassName('headline_colors', colors, 'default');
  const sizeClassName = propClassName('headline_size', size, 'default');
  const componentClassName = cn(variantClassName, colorsClassName, sizeClassName, className);

  return (
    <h3 className={componentClassName} {...props}>
      {children}
    </h3>
  );
};
